/**
 * Parse tab-indented outline text (Bedrock output) into ProgramOutlineEditor lines.
 * Each leading tab = one depth level. Spaces are not counted as indent.
 */
export function outlineTextToLines(text) {
  const emptyLine = () => ({
    id: `ol-${crypto.randomUUID()}`,
    depth: 0,
    text: "",
  });

  const raw = String(text || "").trim();
  if (!raw) return [emptyLine()];

  const rows = raw.split(/\r?\n/).filter((line) => line.trim() !== "");
  if (rows.length === 0) return [emptyLine()];

  return rows.map((line) => {
    let depth = 0;
    while (depth < 12 && line[depth] === "\t") depth++;
    const content = line.slice(depth).trim();
    return {
      id: `ai-${crypto.randomUUID()}`,
      depth,
      text: content,
    };
  });
}
